<template >
  <div v-on:click="handleContentClick($event)">
    <div
      v-ripple
      :class="cms_page.id + '_header' + ' ' + cms_page.parent_id + '_header' + ' ' + 'cms-page-container'"
      v-if="cms_page !== undefined"
    >
      <FavouritesButton
        :item="cms_page"
      />

      <v-img
        class="cms-page__header-image"
        src="@/assets/redcar/page-headers/info-and-advice.png"
      >
      </v-img>


      <div class="cms-content__header-container ">
        <h1>{{hubbdata.home.labels.info}}</h1>
        <h2 v-if="cms_page.page_title">{{ cms_page.page_title }}</h2>
        <div class="tile-list__icon"></div>
      </div>

      <div class="cms-content" v-if="cms_page">
        <div class="desktop-container" v-html="cms_page.html"></div>
      </div>

      <div class="child-pages" v-if="child_pages.length">
        <h2 class="white--text child-pages__heading">
          {{hubbdata.catagories.section}}
        </h2>

        <ul class="child-pages__list">
          <li class="child-pages__list-item" :key="child_page.id" v-for="child_page in child_pages">
            <router-link
              :to="{ name: 'cms_page', params: { id: child_page.id }}"
            >
              <div>
                <span v-if="child_page.page_title">{{ child_page.page_title }}</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      <WasThisUseful
        :type="'cms_page'"
      />
    </div>
  </div>
</template>

<script>
import hubbdata from "@/hubbdata";
import WasThisUseful from "@/components/WasThisUseful/WasThisUseful"
import FavouritesButton from '@/components/Favourites/FavouritesButton.vue';

export default {
  components: {
    WasThisUseful,
    FavouritesButton
  },
  computed: {
    cms_page() {
      return hubbdata.getters.getCmsPageById(this.$route.params.id)
    },
    child_pages() {
      return hubbdata.getters.getCmsPagesByParentId(this.$route.params.id).sort((a,b) => a.position-b.position)
    },
    organisations() {
      return hubbdata.state.organisations
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
  mounted: function() {
    if(this.cms_page.page_title) {
      ga('set', 'title', this.cms_page.page_title); // eslint-disable-line
      ga('send', 'pageview', location.href); // eslint-disable-line
    }
  }
}
</script>

<style lang="scss">
.child-pages {
  text-align: center;
  background-color: $primary;
  text-align: left;
  position: relative;
  top: 40px;
  z-index: 1;

  h2 {
    padding: 8px 20px;
    font-weight: bold;
    font-size: 16px;
    max-width: 790px;
    margin: 0 auto;
  }

  &__list {
    background-color: #90cae8;
  }

  div {
    background-color: #90cae8;
    border-top: 2px solid $white;
    padding: 8px 20px;

    @media screen and (min-width: 960px) {
      border-right: 0px;
      border-top: 0px;
    }
  }
  
  li {
    list-style: none;

    &:last-of-type {
      border-bottom: 2px solid $white;
    }

    .v-icon {
      position: absolute;
      right: -15px;
      top: 10px;
      font-size: 50px;
      color: white !important;
    }
  }

  a {
    display: block;
    text-decoration: none;
    color: black !important;
    max-width: 790px;
    margin: 0 auto;

    &:focus {
      outline-color: $black;
    }
  }

  ul {
    padding-left: 0px;
  }
}

@media screen and (max-width: 500px) {

  .cms-page__header-image {
    height: 250px;

    .v-image__image--cover {
      height: 250px;
      background-position: 80% 0% !important;
    }
  }
}

@media screen and (min-width: 960px) {

  .cms-page__header-image {
    height: 300px;

    .v-image__image--contain {
      height: 300px;
      background-size: cover !important;
    }
  }

  .desktop-container {
    margin: auto;
    max-width: 750px;
  }

  .child-pages__list-item {
    background-color: #90cae8;
    border-bottom: 2px solid white;

    &:first-child {
      border-top: 2px solid white;
    }

    &:last-child {
      border-bottom: 0px;
    }
  }
}

.cms-page__header-image  {
  border-bottom: 3px solid black;

  .v-image__image--cover {
    background-position-y: 80%!important;
  }
}

.cms-page-container {

  .cms-content {
    padding: 20px;

    .desktop-container { // to move cms content up as large gap above it
      top: -70px;
      position:relative;
    }

    img {
      max-width: 100%;
      width: 100vw !important;
      object-fit: cover;
      height: auto!important;
    }
  }

  .cms-content__header-container {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    z-index: 2;
    position: relative;
    top: -100px;
    left: 0;

    h1 {
      color: white;
      font-weight: bold;
      text-shadow: 2px 2px black;
      padding-left: 10px;
    }

    h2, h3 {
      text-align: center;
      padding: 7px;
      padding-left: 25px;
      padding-right: 25px;
      color: white;
      background-color: black;
      text-transform: capitalize;
      font-weight: bold;
    }
  }

  .tile-list__icon {
    margin: 0px 0px 10px 0px;
    text-align: center;
    position: relative;
    bottom: -50px;
    position: absolute;
  }
}
</style>